import { render, staticRenderFns } from "./Send1Icon.vue?vue&type=template&id=72ec02bc&"
import script from "./Send1Icon.vue?vue&type=script&lang=js&"
export * from "./Send1Icon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports